import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/workedHoursReport-actions';
import { WorkedHoursReportActions } from '../constants';

export interface IWorkedHoursReport extends Record<string, unknown> {
    month_start: string;
    provider_id: number;
    full_name: string;
    avg_hours: string;
}

export interface WorkedHoursReportState {
    inProgress: boolean;
    error: string;
    data: Paginated<IWorkedHoursReport>;
}

const initialState: WorkedHoursReportState = {
    inProgress: false,
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

export function workedHoursReports(
    state: WorkedHoursReportState = initialState,
    action: Actions | any,
): WorkedHoursReportState {
    switch (action.type) {
        case requestType(WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS):
            return {
                ...state,
                data: { ...state.data, list: [], inProgress: true },
                error: '',
                inProgress: true,
            };
        case successType(WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: action.payload?.data ?? [],
                    inProgress: false,
                },
                inProgress: false,
            };
        case failureType(WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };
        default:
            return state;
    }
}
